import { render, staticRenderFns } from "./StorageCardSale.vue?vue&type=template&id=2c8d3935&scoped=true&"
import script from "./StorageCardSale.vue?vue&type=script&lang=js&"
export * from "./StorageCardSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8d3935",
  null
  
)

export default component.exports